import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { ModularCarousel } from '@opallabs/periodic/src/ModularCarousel'
import { doNothing } from '../../helpers/functions/doNothing'
import { useValidModules } from '../../helpers/hooks'
import {
  Module,
  OnDragDropProps,
  OnShowAssetPickerProps,
} from '../../helpers/types'
import { StoryMobileSingle } from '../sharedDisplays/StoryMobileSingle'
import { getExpandableStoryModule } from './getExpandableStoryModule'
import { styles } from './styles'

export type Props = {
  accountImage: AssetReference | null
  accountName: string
  allowSharing: boolean
  display: string
  isExpanded: boolean
  isPresenting: boolean
  modules: Module[]
  onAddSection?: () => void
  onDeleteSection?: (index: number) => void
  onDragDrop?: OnDragDropProps
  onExpandAsset?: () => void
  onRemoveAsset?: () => void
  postType: string
  updateSectionPostOption?: (index: number, value: string, name: string) => void
  onShowAssetPicker?: (args: OnShowAssetPickerProps) => void
  readOnly: boolean
}

export const InstagramExpandableStoryAd: React.FC<Props> = ({
  accountImage,
  accountName,
  allowSharing,
  display,
  isExpanded = false,
  isPresenting = false,
  modules = [],
  onAddSection,
  onDeleteSection,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  postType,
  updateSectionPostOption,
  onShowAssetPicker,
  readOnly = false,
}) => {
  const validModules = useValidModules({
    modules,
    onAddSection: onAddSection ? onAddSection : doNothing,
    componentNames: ['ig_expandable_story_link_ad_section'],
  })

  const availableModules = [
    {
      component: StoryMobileSingle,
      componentName: 'ig_expandable_story_link_ad_section',
      title: '',
    },
  ]

  return (
    <div
      css={styles.getBaseStyles(isExpanded)}
      className={kuiperClassNames(
        `instagram instagram-expandable-story-ad instagram-expandable-story-ad-${display}`
      )}
    >
      <ModularCarousel
        addComponentText="Add Story Section"
        allProps={{
          accountImage,
          accountName,
          allowSharing,
          postType,
        }}
        getModule={getExpandableStoryModule}
        isExpanded={isExpanded}
        availableModules={availableModules}
        carouselWidth={375}
        maxSections={10}
        modules={validModules}
        onDragDrop={onDragDrop ? onDragDrop : doNothing}
        onAddSection={onAddSection ? onAddSection : doNothing}
        onDeleteSection={onDeleteSection ? onDeleteSection : doNothing}
        onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
        onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
        onShowAssetPicker={onShowAssetPicker ? onShowAssetPicker : doNothing}
        updateSectionPostOption={
          updateSectionPostOption ? updateSectionPostOption : doNothing
        }
        readOnly={readOnly}
        isPresenting={isPresenting}
      />
    </div>
  )
}
